import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomErrorService {
  public parse(init: {code?: number, message?: any, globalHandler?: boolean}): {code: number, message: string, globalHandler: boolean} {
    return {
      code: init.code || 0,
      message: init.message || null,
      globalHandler: init.globalHandler
    };
  }
}
